import React from 'react';
import tahlilLogo from "../acepts/tahlil.svg";
import Loader from '../Loader/Loader';
import './news.css';

export const news = [
  {
    id: 1,
    desk: "Фарғона водийсида илк бор ягона корпоратив бошқарув, ягона стратегия, ягона кузатув кенгашига қаратилган бизнес тармоқлари MARAFON номи остида бирлашди.",
  },
  {
    id: 2,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
  {
    id: 3,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
  {
    id: 4,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
  {
    id: 5,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
  {
    id: 6,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
  {
    id: 7,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
  {
    id: 8,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
  {
    id: 9,
    desk: "Каддафий Назарбоевга совет ядро қуролини сақлаб қолиш учун 20 миллард доллар таклиф этгани маълум бўлди",
  },
];

function Pop(props) {
    return (
        <div className="popular col-md-3">
        <div className="main_right_title my-3">
          <img src={tahlilLogo} alt="img error" />
          <h2>Popular news</h2>
          </div>
          {news ? news.map((news) => (
            <div className="card mb-3 cart_item" style={{ width: "18rem;" }} data-aos="fade-up">
              <div className="card-body">
                <h6 className="card-subtitle mb-2 text-muted"><i class="bi bi-clock me-2"></i> 21.02.2021  21:00 <span><i class="bi bi-eye-fill mx-2"></i> 756</span></h6>
                <p className="card-text">
                 {news.desk}
                </p>
              </div>
            </div>
          )) : <Loader />}
        
      </div>
    );
}

export default Pop;